<template>
    <div>
        <div class="tile-content">
            <div class="tile-subtitle">
                <h3>Trial</h3>
            </div>
            <p class="stack-m">Your plan may have an optional trial period, and optional price. You can always override this when creating a subscription.</p>
            <div class="grid-content">
                <div class="grid-item grid-item-half grid-item-break-half">
                    <v-checkbox
                        label="Has Trial"
                        :value="true"
                        v-model="hasTrial"
                    />
                </div>
                <div v-if="hasTrial" class="grid-item grid-item-half grid-item-break-half">
                    <p class="stack-s">Trial period</p>
                    <div class="grid-content">
                        <div class="grid-item">
                            <r-input
                                :value="planTrial.period.length"
                                @input="updateTrialPeriodLength"
                                :validate="validate.trial.period.length"/>
                        </div>
                        <div class="grid-item">
                            <v-select
                                :options="timeUnitList"
                                :value="planTrial.period.unit"
                                @input="updateTrialPeriodUnit"
                                :validate="validate.trial.period.unit"/>
                        </div>
                        <div class="grid-item grid-item-half grid-item-break-half">
                            <r-input
                                label="Trial Price"
                                :left-label="currencySign"
                                :value="planTrial.price"
                                help-text="If zero, it will be a free trial."
                                @input="updateTrialPrice"
                                :validate="validate.trial.price"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tile-content">
            <div class="tile-subtitle">
                <h3>Setup</h3>
            </div>
            <p class="stack-m">Sometimes a service may have a setup fee. If your service charges a setup fee, please designate that here. If you want to sell a one-time item, on the other hand, you should consider setting the schedule to never recur. You are not limited to selling only a single plan – subscriptions can have multiple plans, as long as their currency and recurring period (if any) match.</p>
            <div class="grid-content">
                <div class="grid-item grid-item-half grid-item-break-half">
                    <v-checkbox
                        label="Has Setup"
                        :value="true"
                        v-model="hasSetup"
                    />
                </div>
                <div v-if="hasSetup" class="grid-item grid-item-half grid-item-break-half">
                    <div class="grid-content">
                        <div class="grid-item grid-item-half grid-item-break-half">
                            <r-input
                                label="Setup Price"
                                :left-label="currencySign"
                                :value="planSetup.price"
                                @input="updatedSetupPrice"
                                :validate="validate.setup.price"/>
                        </div>
                        <!-- Todo - Billing Timing -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Todo - Quantity -->
        <!-- <div class="tile-content">
            <div class="tile-subtitle">
                <h3>Quantity</h3>
            </div>
            <p class="stack-m">Most metered-based billing is done in arrears (after the service is delivered) as opposed to in advance. It may be common to license 10 seats for a software product in advance, and charge based on usage, for example, per GB of storage, in arrears. If you are selling a service that has both types of pricing at the same time, you would make multiple pricing plans.</p>
        </div> -->
    </div>
</template>
<script>
    import {
        vSelect, vIcon, vCheckbox, vIconButton,
    } from '@/components/form';
    import _ from '@/common/helpers';

    export default {
        name: 'advance-configuration',
        components: {
            vSelect,
            vIcon,
            vCheckbox,
            vIconButton,
        },
        props: {
            planTrial: {
                type: Object,
            },
            planSetup: {
                type: Object,
            },
            currencySign: {
                type: String,
            },
            validate: {
                type: Object,
                default: null,
            },
        },
        computed: {
            hasTrial: {
                get() {
                    return this.planTrial !== null;
                },
                set(value) {
                    this.$emit('input', {
                        setup: this.planSetup,
                        trial: !value ? null : {
                            price: null,
                            period: {
                                unit: null,
                                length: null,
                            },
                        },
                    });
                    this.$emit('trial', value);
                },
            },
            hasSetup: {
                get() {
                    return this.planSetup !== null;
                },
                set(value) {
                    this.$emit('input', {
                        trial: this.planTrial,
                        setup: !value ? null : {price: null},
                    });
                    this.$emit('setup', value);
                },
            },
            timeUnitList() {
                return [
                    {label: this.timeUnitToPlural('day'), value: 'day'},
                    {label: this.timeUnitToPlural('week'), value: 'week'},
                    {label: this.timeUnitToPlural('month'), value: 'month'},
                    {label: this.timeUnitToPlural('year'), value: 'year'},
                ];
            },
        },
        methods: {
            timeUnitToPlural(unit) {
                return _.pluralize(unit, this.planTrial.period.length);
            },
            updateTrialPeriodLength(length) {
                this.$emit('input', {
                    setup: this.planSetup,
                    trial: {
                        price: this.planTrial.price,
                        period: {
                            unit: this.planTrial.period.unit,
                            length,
                        },
                    },
                });
            },
            updateTrialPeriodUnit(unit) {
                this.$emit('input', {
                    setup: this.planSetup,
                    trial: {
                        price: this.planTrial.price,
                        period: {
                            unit,
                            length: this.planTrial.period.length,
                        },
                    },
                });
            },
            updateTrialPrice(price) {
                this.$emit('input', {
                    setup: this.planSetup,
                    trial: {
                        price,
                        period: {
                            unit: this.planTrial.period.unit,
                            length: this.planTrial.period.length,
                        },
                    },
                });
            },
            updatedSetupPrice(price) {
                this.$emit('input', {
                    trial: this.planTrial,
                    setup: {price},
                });
            },
        },
    };
</script>
